import React, { Component } from 'react'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import DataTable from '../../../../DataTable/DataTable'
import { withTranslate } from 'react-redux-multilingual'
import { Scrollbars } from 'react-custom-scrollbars'
import NoDataDisplay from '../../../../NoDataDisplay/NoDataDisplay'
import _ from 'lodash/core'

class ForceRankTable extends Component {
  state = {
    adjustData: [],
    gradeData: [],
    saveGrade: [],
    data: [],
    unData: [],
    unAdjust: [],
    show: true,
    filterData: [],
    adjust: [],
    chart: [],
    updateChart: [],
    param: [],
    checkTotal: [],
    valid: false,
    adjust_grade: {
      label: 'Adjust Grade',
      elementType: 'newselect',
      elementConfig: {
        type: 'text',
        placeholder: 'Adjust Grade',
        options: [],
        clearDisabled: true
      },
      value: '',
      validation: {
        required: true
      },
      valid: false,
      touched: false,
      error: null
    }
  }

  static getDerivedStateFromProps (props, state) {
    if (props.data !== state.data) {
      let Data = props.data
      let updateChart = []
      let chart = []
      let checkTotal = []
      chart = props.gradeData.map(grade => ({
        grade: grade.value_list_name,
        adjust_grade: grade.value_list_id,
        total: grade.amount
      }))

      updateChart = props.gradeData.map(grade => ({
        grade: grade.value_list_name,
        adjust_grade: grade.value_list_id,
        total: Data[grade.value_list_name]?.length || 0
      }))

      updateChart.map(item => {
        chart.map(check => {
          if (item.grade === check.grade) {
            if (item.total !== check.total) {
              checkTotal.push(
                `${item.grade} ${+check.total - +item.total > 0 ? '+' : ''}${+check.total -
                  +item.total}`
              )
            }
          }
          return check
        })
        return item
      })

      let adjust_grade = state.adjust_grade
      props.adjust_grade(updateChart)
      props.valid(true)
      props.dataAdjust(props.adjustRaw)
      let checkGrade = _.isEqual(chart, updateChart)
      props.checkGrade(checkGrade)
      return {
        data: props.data,
        adjust: props.adjustRaw,
        chart: chart,
        updateChart: updateChart,
        checkTotal: checkTotal,
        adjust_grade: {
          ...adjust_grade,
          elementConfig: {
            ...adjust_grade.elementConfig,
            options: props.adjust_option
          }
        }
      }
    }
    return {
      adjust: props.adjustRaw
    }
  }

  gradeChanged = (rowData, e) => {
    let oldGrade = ''
    let checkTotal = []
    let update = this.state.adjust.map(item => {
      if (item.emp_code === rowData.emp_code) {
        oldGrade = item.adjust_grade
        return {
          ...item,
          adjust_grade_label: e.label,
          adjust_grade: e.key
        }
      } else {
        return item
      }
    })

    let updateChart = this.state.updateChart.map(item => {
      if (oldGrade !== e.key) {
        if (item.adjust_grade === e.key) {
          return {
            ...item,
            total: item.total + 1
          }
        } else if (item.adjust_grade === oldGrade) {
          return {
            ...item,
            total: item.total - 1
          }
        } else {
          return item
        }
      } else {
        return item
      }
    })
    this.props.adjust_grade(updateChart)
    // this.props.valid_count(this.checkGrade())
    // validate
    let valid = true
    updateChart.map(up => {
      this.state.chart.map(ol => {
        if (up.adjust_grade === ol.adjust_grade) {
          valid = valid && up.total === ol.total
        }
        return ol
      })
      return up
    })
    let adjust = []
    update.map(attrs => {
      adjust.push({
        ...attrs
      })

      return attrs
    })

    let param = {
      adjust
    }
    this.props.fetchForceRankCalculate(param)
    this.props.dataAdjust(update)

    this.props.valid(valid)

    updateChart.map(item => {
      this.state.chart.map(check => {
        if (item.grade === check.grade) {
          if (item.total !== check.total) {
            checkTotal.push(
              `${item.grade} ${+check.total - +item.total > 0 ? '+' : ''}${+check.total -
                +item.total}`
            )
          }
        }
        return check
      })
      return item
    })

    this.setState({
      checkTotal: checkTotal,
      adjust: update,
      updateChart: updateChart,
      valid: valid
    })
    this.checkGrade(this.state.chart, updateChart)
  }

  checkGrade = (chart, update) => {
    let checkGrade = _.isEqual(chart, update)
    this.props.checkGrade(checkGrade)
  }

  structureForIndex = [
    { field: 'no', title: this.props.translate('no'), type: 'string' },
    { field: 'emp_code', title: this.props.translate('empCode'), type: 'string' },
    { field: 'emp_name', title: this.props.translate('employeeName'), type: 'string' },
    { field: 'level_name', title: this.props.translate('level'), type: 'string' },
    { field: 'position_name', title: this.props.translate('position'), type: 'string' },
    { field: 'org_name', title: this.props.translate('organizationName'), type: 'string' },
    {
      field: 'status',
      title: this.props.translate('status'),
      type: 'string',
      width: 150
    },
    { field: 'result_score', title: this.props.translate('score'), type: 'string' },
    { field: 'grade', title: this.props.translate('grade'), type: 'string' },
    {
      field: 'adjust_grade',
      title: this.props.translate('adjust'),
      width: 200,
      render: rowData => {
        let index = this.state.adjust_grade?.elementConfig?.options.findIndex(
          item => item.key === rowData?.grade_id
        )
        let options = this.state.adjust_grade?.elementConfig?.options.filter(
          (item, i) => i === index || i === index - 1 || i === index + 1
        )

        return this.props.show === true ? (
          <div>
            <InputGroup
              inputType={'newselect'}
              noMargin
              label={''}
              inputValue={{
                key: rowData.adjust_grade,
                value: rowData.adjust_grade,
                label: rowData.adjust_grade_label
              }}
              configs={{ ...this.state.adjust_grade?.elementConfig, options }}
              changed={e => this.gradeChanged(rowData, e)}
            />
          </div>
        ) : null
      },
      cellStyle: {
        width: 150,
        minWidth: 150
      },
      headerStyle: {
        width: 150,
        minWidth: 150
      }
    }
    // { field: 'raise_amount', title: this.props.translate('raiseAmount'), type: 'string' },
    // { field: 'raise_%', title: this.props.translate('raise'), type: 'string' },
    // { field: 'salary', title: this.props.translate('salary'), type: 'string' },
    // { field: 'new_salary', title: this.props.translate('newSalary'), type: 'string' },
    // { field: 'bonus', title: this.props.translate('bonus'), type: 'string' }
  ]

  render () {
    let table = <NoDataDisplay />
    let errorText =
      this.state.checkTotal.length > 0
        ? `ระบบเกรดไม่ถูกต้อง ( ${this.state.checkTotal.toString()} )`
        : null
    if (this.state.adjust.length !== 0) {
      table = (
        <DataTable
          data={this.state.adjust}
          loading={this.props.loading}
          tableTitle={this.props.translate('forceRankTable')}
          structure={
            this.props.showStatus
              ? this.structureForIndex
              : this.structureForIndex.filter(s => s?.field !== 'status')
          }
          paginationDisabled={true}
          rowActions={this.rowActions}
          errorText={errorText}
          options={{ headerStyle: { position: 'sticky', top: 0 }, maxBodyHeight: '400px' }}
        />
      )
    }

    return (
      <Scrollbars autoHide style={{ height: '400px', maxHeight: '400px' }}>
        {table}
      </Scrollbars>
    )
  }
}

export default withTranslate(ForceRankTable)
